import { getCookies } from "../../shared/utilities/auth";

export const logger = (err, response, body) => {
  if (!err && response.statusCode === 200) {
    console.log("response", body);
  } else {
    console.log("ERROR");
  }
};

export const arrayBufferToBase64 = buffer => {
  var binary = "";
  var bytes = [].slice.call(new Uint8Array(buffer));
  bytes.forEach(b => (binary += String.fromCharCode(b)));
  return window.btoa(binary);
};

export const jsonToQuery = data =>
  Object.entries({ ...getCookies(), ...data })
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

export default { arrayBufferToBase64, jsonToQuery, logger };
